export enum DashboardModalTypes {
  ISSUES = 'issues',
  FOLLOW_UP = 'followUp',
  HEALTHCHECK = 'healthcheck',
  CHANGE_ZONE = 'changeZone',
}
